import React from "react";
import "./contact.scss";
import phone from "../../assets/UMSImage/Phone.png";
import email from "../../assets/UMSImage/Contact_Icons.png";
import WhitePhone from "../../assets/UMSImage/whitePhone.png"
import WhiteEmail from "../../assets/UMSImage/whiteEmail.png"
import Button from "../Common/Button/Button";

const ContactUs = () => {
  return (
    <section id="contact-us-wrapper">
      <div className="row">
        <div className="col-md-6 contactUs">
          <div className="contact-deatils">
          <img src={WhitePhone} alt="" className="hover-image" />
            <img src={phone} alt="" />
            <a href="tel:+13026080876">(302) 608-0876</a>
            <a href="tel:+18889083523" className="toll">
              Toll Free (888) 908-3523
            </a>
          </div>
          <div className="contact-deatils mt-5">
            <img src={WhiteEmail} alt="" className="hover-image"  />
            <img src={email} alt="" />
            <a href="mailto:support@theums.us">support@theums.us</a>
          </div>
        </div>
        <div className="col-md-6">
          <h2>
            Get In Touch <span>With Us</span>
          </h2>
          <form>
            <div className="user-deatils">
              <input type="text" placeholder="First Name" />
              <input type="text" placeholder="Last Name" />
            </div>
            <input type="text" placeholder="Write here your email" />
            <input type="text" placeholder="I would like to discuss" />
            <textarea name="" id=""  rows="" placeholder="Write Comments"></textarea>
            <Button id="arrow-wrapper-right">Send Message</Button>
          </form>
        </div>
      </div>
    </section>
  );
};

export default ContactUs;
